export default __webpack_public_path__ + "static/media/61_mobile.e92ee092.jpg";